.segment {
  flex: 1 0 0;
  min-width: var(--sizes-spacing-0-5);
  height: var(--sizes-spacing-1-5);
  border-radius: var(--sizes-radius-full);
}

.filled {
  background-color: var(--palette-bg-neutral-inverse);
}

.unfilled {
  background-color: var(--palette-bg-neutral-medium);
}

.reviewed {
  background-color: var(--palette-bg-status-info);
}

.halfStart {
  background: linear-gradient(to right, var(--palette-bg-neutral-inverse) 50%, var(--palette-bg-neutral-medium) 50%);
}

.halfEnd {
  background: linear-gradient(to right, var(--palette-bg-neutral-medium) 50%, var(--palette-bg-neutral-inverse) 50%);
}

.label {
  flex: 1 0 0;
  min-width: 0;
  text-align: center;
}
